import { openCrisp } from '@/helpers';
import { EmptyState } from '@shopify/polaris';
import React from 'react';

type TEmptyStatePage = {
  heading: string;
  textEmptyState: string;
  contentAction: string;
  onAction: () => void;
  imageUrl: string;
  customFooter?: React.JSX.Element;
};

const EmptyStatePage = ({
  heading,
  textEmptyState,
  contentAction,
  onAction,
  imageUrl,
  customFooter = undefined,
}: TEmptyStatePage) => {
  return (
    <>
      <EmptyState
        heading={heading}
        action={{
          content: contentAction,
          onAction: onAction,
        }}
        secondaryAction={{
          content: 'Contact support',
          onAction: openCrisp,
        }}
        image={imageUrl}
        footerContent={customFooter}
      >
        {textEmptyState}
      </EmptyState>
    </>
  );
};

export default EmptyStatePage;
